<template>
	<a
		class="booking"
		href="mailto:band@elitepartner.band?subject=Booking-Anfrage"
		title="Booking"
		aria-label="Booking per E-Mail"
	>
		<span>Booking</span>
	</a>
</template>

<script>
export default {
	name: 'Booking'
}
</script>
